import SmartSearch from "../SmartSearch";

/**
 * Homepage SmartSearch — sticky pill that stays beneath the boutique header
 * the entire scroll so the customer is always one tap away from search.
 * Trending chips were removed because the SmartSearch dropdown already
 * surfaces trending suggestions when the input is focused — having both
 * created visual clutter and gave the homepage two "search affordances".
 */
export default function DiscoverySearch({ items = [] }) {
    return (
        <div
            className="sticky top-[var(--app-header-h,6rem)] z-30 -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8 py-3 bg-ivory/85 backdrop-blur-md border-b border-stone-200/60"
            data-testid="shop-discovery-sticky"
        >
            <div className="max-w-2xl mx-auto">
                <SmartSearch
                    items={items}
                    placeholder="Search styles, occasions, colours or festive looks…"
                    data-testid="shop-search"
                />
            </div>
        </div>
    );
}
